module.exports = __webpack_public_path__ + "static/media/Mask.942d5e8f.svg";